import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel"] */ "/codebuild/output/src2163433464/src/app/src/v2/components/Carousel/Carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsLetterCta"] */ "/codebuild/output/src2163433464/src/app/src/v2/components/NewsLetterCTA/NewsLetterCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/codebuild/output/src2163433464/src/app/src/v2/containers/Header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopularTeamsList"] */ "/codebuild/output/src2163433464/src/app/src/v2/containers/PopularTeams/PopularTeamsList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Search"] */ "/codebuild/output/src2163433464/src/app/src/v2/containers/Search/Search.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UsageInstructionsSection"] */ "/codebuild/output/src2163433464/src/app/src/v2/containers/UsageInstructionsSection/UsageInstructionsSection.tsx");
